/** @format */

import { Pipe, PipeTransform } from '@angular/core';

import { DatePipeIntervals } from '../models/date-pipe.interface';

@Pipe({
	name: 'dateAgo',
	standalone: true
})
export class DateAgoPipe implements PipeTransform {
	transform(value: string): string {
		if (!value) {
			return '';
		}
		const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
		if (seconds < 29) {
			// less than 30 seconds ago will show as 'Just now'
			return 'Just now';
		}
		const intervals: DatePipeIntervals = {
			year: 31536000,
			month: 2592000,
			week: 604800,
			day: 86400,
			hour: 3600,
			minute: 60,
			second: 1
		};
		let counter = 0;

		for (const i in intervals) {
			if (typeof intervals[i] !== 'undefined') {
				// This will round down 2.99 months to "2 months ago" even though it's practically 3.
				counter = Math.floor(seconds / intervals[i]);
				if (counter > 0) {
					const pluralOrSingular = counter > 1 ? 's' : '';
					return `${counter} ${i}${pluralOrSingular} ago`;
				}
			}
		}
		return value;
	}
}
